export default __webpack_public_path__ + "static/media/triporate.theme.03a1102f.less";